import { ConfirmDialog } from "@/components/ui/ConfirmDialog";
import { Picker, type PickerItem } from "@/components/ui/Picker";
import { Building2, Plus } from "lucide-react";
import React from "react";

export interface FirmContextDropdownViewProps {
  items: PickerItem[];
  value: string | null;
  displayLabel: string | null;
  isLoading: boolean;
  disabled: boolean;
  commandEmptyLabel: string;
  isCreateEnabled: boolean;
  onChangeFirm: (firmId: string) => void;
  onCreateFirm: (label: string) => false | void;
  pendingFirmName: string | null;
  isCreatingFirm: boolean;
  onConfirmCreateFirm: () => void;
  onCancelCreateFirm: () => void;
  groupOrder: string[];
}

export const FirmContextDropdownView = ({
  items,
  value,
  onChangeFirm,
  onCreateFirm,
  pendingFirmName,
  isCreatingFirm,
  onConfirmCreateFirm,
  onCancelCreateFirm,
  displayLabel,
  isLoading,
  disabled,
  commandEmptyLabel,
  isCreateEnabled,
  groupOrder,
}: FirmContextDropdownViewProps) => {
  return (
    <>
      <div className="firm-section-container">
        <div className="menu-section-label">FIRM CONTEXT</div>
        <div className="firm-section">
          <div className="firm-select-wrapper firm-dropdown">
            <Picker
              items={items}
              value={value}
              onChange={onChangeFirm}
              onCreateItem={isCreateEnabled ? onCreateFirm : undefined}
              placeholder="Select firm..."
              searchPlaceholder="Find or create a firm..."
              displayLabel={displayLabel}
              isLoading={isLoading}
              disabled={disabled}
              commandEmptyLabel={commandEmptyLabel}
              groups
              groupOrder={groupOrder}
              sortItems
              triggerChevronVariant="chevron"
              holdOpen={pendingFirmName !== null}
            />
          </div>
        </div>
      </div>
      <ConfirmDialog
        open={pendingFirmName !== null}
        onOpenChange={(open) => {
          if (!open) onCancelCreateFirm();
        }}
        icon={Building2}
        confirmIcon={Plus}
        title={
          <>
            Create new <span className="text-primary">{pendingFirmName}</span> firm?
          </>
        }
        description={
          <>
            A firm named <strong>{pendingFirmName}</strong> doesn&apos;t exist. Create it and assign
            yourself as super admin?
          </>
        }
        confirmLabel="Create firm"
        onConfirm={onConfirmCreateFirm}
        isConfirming={isCreatingFirm}
      />
    </>
  );
};
